<template>
  <NewBsBox
    ref="tr"
    :bs="{
      'cmp.table.tbody': 'tr',
      'cmp.table.tbody.trMouseenterActive': mouseenterActive,
      'td': {
        bg: statusColor,
        ...statusBs,
      },
      ...bs,
    }"
    :status-selected="this.isSelected"
    as="tr"
    @click="$emit('click', {
      rowData,
      rowIndex,
    })"
    @mouseenter="shouldFixedColumn ? $emit('mouseenter', rowIndex) : $emit('noEvent')"
    @mouseleave="shouldFixedColumn ? $emit('mouseleave') : $emit('noEvent')"
  >
    <slot />
  </NewBsBox>
</template>

<script>
  import { isString, isObject, debounce } from 'lodash'
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
  import { tableRowStatusColors } from './style'

  export default {
    components: {
      NewBsBox,
    },
    props: {
      mouseenterActive: {
        type: Boolean,
        default: false,
      },
      striped: Boolean,
      rowStatus: Function,
      rowIndex: Number,
      rowData: Object,
      currentSelect: Number,
      shouldFixedColumn: Boolean,
      shouldClacHeight: Boolean, // column fixed table 需要计算每个单元格的高度
      bs: {
        type: Object,
        default: () => ({}),
      },
    },
    emits: ['click', 'tbodyTrHeightChange', 'mouseenter', 'mouseleave', 'noEvent'],
    computed: {
      isSelected() {
        return this.currentSelect === this.rowIndex
      },
      statusStyle() {
        return this.rowStatus(this.rowIndex, this.rowData)
      },
      statusColor() {
        if (isString(this.statusStyle) && this.rowStatus) {
          if (tableRowStatusColors[this.statusStyle]) {
            return tableRowStatusColors[this.statusStyle]
          }
          return this.statusStyle
        }
        return null
      },
      statusBs() {
        if (isObject(this.statusStyle) && this.rowStatus) {
          return this.statusStyle
        }
        return {}
      },
    },
    watch: {
      rowData: {
        immediate: true,
        handler() {
          if (!this.shouldClacHeight) {
            return
          }
          this.$nextTick(() => this.changeHeight())
        },
      },
    },
    mounted() {
      if (!this.shouldClacHeight) {
        return
      }
      window.addEventListener('resize', debounce(this.changeHeight, 300))
    },
    methods: {
      changeHeight() {
        if (this.$refs.tr) {
          this.$emit('tbodyTrHeightChange', {
            rowIndex: this.rowIndex,
            height: this.$refs.tr.$el.offsetHeight,
          })
        }
      },
    },
  }
</script>
